import {WaihonaUserRef} from "../domain/user/WaihonaUserRef";
import {Organization, OrganizationFlags} from "../domain/organization/Organization";
import {ContactInfo, ContactInfoType} from "../domain/organization/ContactInfo";
import {WaihonaUser} from "../domain/user/WaihonaUser";
import {WaihonaUserOrganization} from "../domain/user/WaihonaUserOrganization";
import {Role, RoleType} from "../domain/user/Role";
import {NewUserRegistration} from "../domain/user/NewUserRegistration";

export class KealaiwikuamooStubData {

	public static first_kabright:string = "Kalani";
	public static altFirstName_kabright:string = "";
	public static last_kabright:string = "Bright";
	public static uid_kabright:string = "kalani-bright";
	public static bio_kabright:string = "Kalani grew up on Kauaʻi in rural Wailua Home working on his family’s bird farm raising parrots and other birds. From a very young age (while still spending lots of time playing outdoors) he developed an interest in computer games from his families first Tandy 2000 Computer in the early 80’s. Kalani grew up teaching himself programming, game development, and web design from reading books he would pick up from trips to Honolulu and California. Kalani stayed in Hawaiʻi working in web design then left in 2003 to study Video Game Art & Design in San Diego; having an interest in educational games, he followed with a second degree in Learning Design & Technology. Kalani worked in the tech sector developing apps, software, and services for high tech businesses. He is experienced in art and software development. Kalani’s passion and mission revolves around developing apps, software, games, and cloud services centered around Hawaiian Language and Culture. He has recently returned to Hawaiʻi after 14 years away and is now employed in his dream job building apps, games, and server side technologies for Hawaiian Audiences. Its Kalani’s hope that Hawaiʻi’s youth can grow up into a thriving tech industry here which promotes authentic Hawaiian values and culture, that creates a sense of place and identity, and increases our sustainability and connectedness with each other, while strengthening our independence.";

	public static first_chjones:string = "Chryssa";
	public static altFirstName_chjones:string = "";
	public static last_chjones:string = "Jones";
	public static uid_chjones:string = "chryssa-jones";
	public static bio_chjones:string = "<p>Chryssa Keʻalaokamaile Jones is the shape-shifter of the development team.  Her broad career experience includes writing and editing, marketing, manufacturing and operations, retail management, community development, public speaking, travel and event planning,  theatrical production, college-level teaching as adjunct faculty, and university administration as a registrar, an applications reader, and a student affairs director.   After all that and still unable to decide what she wants to do when she grows up, Chryssa learned some new skills and joined the the creative folks on the Kealaiwikuamoʻo team.</p><p>Chryssa earned her B.S. in Business Management from Brigham Young University Hawaiʻi with dual minors in Hawaiian Language and Economics, and her M.B.A. degree in Management, with honors, from Hawaiʻi Pacific University.  Formerly an ʻAha Pūnana Leo scholar and mākua as well as a Kamehameha Schools scholar, Chryssa is grateful for the opportunity to be reconnected to the Hawaiian community and put her long-forgotten ʻōlelo skills to use.</p><p>Chryssa can fly airplanes and loves to travel, enjoys cooking and gardening, volunteering in her Koʻolauloa community, making messes with paint and clay, skiing and ice skating, horseback riding, and spending time with her family.</p>";

	public static first_wybartle:string = "Wyatt";
	public static altFirstName_wybartle:string = "Maui";
	public static last_wybartle:string = "Bartlett";
	public static uid_wybartle:string = "wyatt-bartlett";
	public static bio_wybartle:string = "<p>Aloha kākou. ʻO au ʻo Maui Bartlett, no nā Hono a Piʻilani mai, no Nāpili ua pulu ʻelo i ka ua Nōweoʻula. He pua nō au a Pauahi, a ʻo ʻAʻapueo kahi i mohala maila. Ma ka ʻāina uluwehi i ka ua Tuahine i loaʻa mai ai ke kēkelē laepua ma ka ʻEpekema Lolouila. ʻO ka ʻōlelo Hawaiʻi kaʻu māina. Ke kākoʻo nei nō au i ke Kime Duolingo ma ka hoʻonohonoho ʻana i nā hopuna ʻōlelo a me nā kani leo i loko o ka ʻōnaehana ʻo Duolingo.</p><p>Maui Bartlett provides technical support and feedback to the Duolingo Development Team. He received his B.S. in Computer Science from the University of Hawaiʻi at Mānoa, while also minoring in Hawaiian Language. He hails from Nāpili on the island of Maui, and is a proud graduate of the Kamehameha Schools Maui campus</p>";

	public static first_rygonzal:string = "Ryan";
	public static altFirstName_rygonzal:string = "Gonzo";
	public static last_rygonzal:string = "Gonzalez";
	public static uid_rygonzal:string = "ryan-gonzalez";
	public static bio_rygonzal:string = "Ryan “Gonzo” Gonzalez loves amplifying mo‘olelo through different forms of media in an effort to influence and impact how systems think and operate. He has spent the past 22 years working with and for Hawaiian communities in various roles. He is a digital artist, an award winning musician and composer, a director and producer of video things, and an old school web designer and developer. Mostly he tinkers. He is currently the Network Engagement Director in Kealaiwikuamo’o, a department within Kamehameha Schools that supports Kanaeokana, a network of over 60 schools and organizations committed to growing the next generations of aloha ‘āina leaders. As the director of Network Engagement, he has successfully surrounded himself with smarter and much more talented people and somehow tricked them into thinking that he’s not an idiot. Together, they create, build, and run all the communications and tech stuff for Kanaeokana. He also loves mud pie ice cream.";

	public static first_keabad:string = "Kēhaunani";
	public static altFirstName_keabad:string = "Kēhau";
	public static last_keabad:string = "Abad";
	public static uid_keabad:string = "kehaunani-abad";
	public static bio_keabad:string = "Kēhaunani Abad has spent years as a Hawaiian history and culture teacher wishing there were more engaging teaching resources for haumāna, trying to create some herself with meagre outcomes. Since then she’s had the great fortune of being a member of teams comprised of talented, tech-savvy folks working for visionary Hawaiian education leaders who as a collective are on the brink of bringing both old and new dreams to reality. She currently leads the Kealaiwikuamoʻo Department within Kamehameha Schools’ Kūamahi Community Education Division. Kealaiwikuamoʻo is dedicated to facilitating collaboration among the Kanaeokana network of P-20+ Hawaiian-focused schools and organizations whose vision is to grow and sustain the next generations of aloha ʻāina leaders.";

	public get kalani_waihonaUserReference():WaihonaUserRef {
		return WaihonaUserRef.create(KealaiwikuamooStubData.uid_kabright, KealaiwikuamooStubData.first_kabright, KealaiwikuamooStubData.last_kabright, KealaiwikuamooStubData.altFirstName_kabright);
	}

	public get chjones_waihonaUserReference():WaihonaUserRef {
		return WaihonaUserRef.create(KealaiwikuamooStubData.uid_chjones, KealaiwikuamooStubData.first_chjones, KealaiwikuamooStubData.last_chjones, KealaiwikuamooStubData.altFirstName_chjones);
	}

	public get wybartle_waihonaUserReference():WaihonaUserRef {
		return WaihonaUserRef.create(KealaiwikuamooStubData.uid_wybartle, KealaiwikuamooStubData.first_wybartle, KealaiwikuamooStubData.last_wybartle, KealaiwikuamooStubData.altFirstName_wybartle);
	}

	public get rygonzal_waihonaUserReference():WaihonaUserRef {
		return WaihonaUserRef.create(KealaiwikuamooStubData.uid_rygonzal, KealaiwikuamooStubData.first_rygonzal, KealaiwikuamooStubData.last_rygonzal, KealaiwikuamooStubData.altFirstName_rygonzal);
	}

	public get keabad_waihonaUserReference():WaihonaUserRef {
		return WaihonaUserRef.create(KealaiwikuamooStubData.uid_keabad, KealaiwikuamooStubData.first_keabad, KealaiwikuamooStubData.last_keabad, KealaiwikuamooStubData.altFirstName_keabad);
	}

	public get chjones_waihonaUser():WaihonaUser {
		let chjones:WaihonaUser = new WaihonaUser();
		chjones.guid = KealaiwikuamooStubData.uid_chjones;
		chjones.firstName = KealaiwikuamooStubData.first_chjones;
		chjones.altFirstName = KealaiwikuamooStubData.altFirstName_chjones;
		chjones.lastName = KealaiwikuamooStubData.last_chjones;
		chjones.professionalName = "Chryssa Jones";
		chjones.documentTextContent.en.bio = KealaiwikuamooStubData.bio_chjones;

		//todo: this is not working... make it work!
		chjones.roles.push(
			new Role(RoleType.registered),
			new Role(RoleType.waihonaAdmin),
			new Role(RoleType.organizationAdmin)
		);


		let org:WaihonaUserOrganization = new WaihonaUserOrganization();
		org.currentlyAt = true;
		org.organizationGuid = "kealaiwikuamoo";
		org.pendingApproval = false;
		org.needsToAcceptInvite = false;
		org.default = true;
		org.userTitle = "Code Wrangler";
		org.organizationName = "Kealaiwikuamoʻo at Kamehameha Schools";

		chjones.organizations.push(org);

		return chjones;
	}

	public get kabright_waihonaUser():WaihonaUser {
		let kabright:WaihonaUser = new WaihonaUser();
		kabright.guid = KealaiwikuamooStubData.uid_kabright;
		kabright.firstName = KealaiwikuamooStubData.first_kabright;
		kabright.altFirstName = KealaiwikuamooStubData.altFirstName_kabright;
		kabright.lastName = KealaiwikuamooStubData.last_kabright;
		kabright.professionalName = "Kalani Bright";
		kabright.documentTextContent.en.bio = KealaiwikuamooStubData.bio_kabright;

		kabright.roles.push(
			new Role(RoleType.registered),
			new Role(RoleType.waihonaAdmin),
			new Role(RoleType.organizationAdmin)
		);

		let org:WaihonaUserOrganization = new WaihonaUserOrganization();
		org.currentlyAt = true;
		org.organizationGuid = "kealaiwikuamoo";
		org.pendingApproval = false;
		org.needsToAcceptInvite = false;
		org.default = true;
		org.userTitle = "Bringer of Edamame";
		org.organizationName = "Kealaiwikuamoʻo at Kamehameha Schools";


		kabright.organizations.push(org);
		return kabright;
	}

	public get wybartle_waihonaUser():WaihonaUser {
		let wybartle:WaihonaUser = new WaihonaUser();
		wybartle.guid = KealaiwikuamooStubData.uid_wybartle;
		wybartle.firstName = KealaiwikuamooStubData.first_wybartle;
		wybartle.altFirstName = KealaiwikuamooStubData.altFirstName_wybartle;
		wybartle.lastName = KealaiwikuamooStubData.last_wybartle;
		wybartle.professionalName = "Maui Bartlett";
		wybartle.documentTextContent.en.bio = KealaiwikuamooStubData.bio_wybartle;

		wybartle.roles.push(
			new Role(RoleType.registered),
			new Role(RoleType.waihonaAdmin),
			new Role(RoleType.organizationAdmin)
		);

		let org:WaihonaUserOrganization = new WaihonaUserOrganization();
		org.currentlyAt = true;
		org.organizationGuid = "kealaiwikuamoo";
		org.needsToAcceptInvite = false;
		org.pendingApproval = false;
		org.default = true;
		org.userTitle = "Grammar Programmer";
		org.organizationName = "Kealaiwikuamoʻo at Kamehameha Schools";

		wybartle.organizations.push(org);
		return wybartle;
	}

	public get rygonzal_waihonaUser():WaihonaUser {
		let rygonzal:WaihonaUser = new WaihonaUser();
		rygonzal.guid = KealaiwikuamooStubData.uid_rygonzal;
		rygonzal.firstName = KealaiwikuamooStubData.first_rygonzal;
		rygonzal.altFirstName = KealaiwikuamooStubData.altFirstName_rygonzal;
		rygonzal.lastName = KealaiwikuamooStubData.last_rygonzal;
		rygonzal.professionalName = "Ryan Gonzalez";
		rygonzal.documentTextContent.en.bio = KealaiwikuamooStubData.bio_rygonzal;

		rygonzal.roles.push(
			new Role(RoleType.registered),
			new Role(RoleType.organizationAdmin)
		);

		let org:WaihonaUserOrganization = new WaihonaUserOrganization();
		org.currentlyAt = true;
		org.organizationGuid = "kealaiwikuamoo";
		org.pendingApproval = false;
		org.needsToAcceptInvite = false;
		org.default = true;
		org.userTitle = "Lead Goofball Not in Charge";
		org.organizationName = "Kealaiwikuamoʻo at Kamehameha Schools";

		rygonzal.organizations.push(org);
		return rygonzal;
	}


	public get keabad_waihonaUser():WaihonaUser {
		let keabad:WaihonaUser = new WaihonaUser();
		keabad.guid = KealaiwikuamooStubData.uid_keabad;
		keabad.firstName = KealaiwikuamooStubData.first_keabad;
		keabad.altFirstName = KealaiwikuamooStubData.altFirstName_keabad;
		keabad.lastName = KealaiwikuamooStubData.last_keabad;
		keabad.professionalName = "Kēhaunani Abad";
		keabad.documentTextContent.en.bio = KealaiwikuamooStubData.bio_keabad;

		keabad.roles.push(
			new Role(RoleType.registered),
			new Role(RoleType.organizationAdmin)
		);

		let org:WaihonaUserOrganization = new WaihonaUserOrganization();
		org.currentlyAt = true;
		org.organizationGuid = "kealaiwikuamoo";
		org.pendingApproval = false;
		org.needsToAcceptInvite = false;
		org.default = true;
		org.userTitle = "Director of Kealaiwikuamoʻo";
		org.organizationName = "Kealaiwikuamoʻo at Kamehameha Schools";

		keabad.organizations.push(org);
		return keabad;
	}

	public getKealaiwikuamoo():Organization {
		let kealaiwikuamoo:Organization = new Organization();
		kealaiwikuamoo.guid = "kealaiwikuamoo";
		kealaiwikuamoo.title = "Kealaiwikuamoʻo at Kamehameha Schools";
		kealaiwikuamoo.documentTextContent.en.description = "<p>Kealaiwikuamoʻo: Ke ala (the path) of the Iwikuamo‘o (trusted chiefly attendant and counselor) is an aspirational name that the Kamehameha Schools department of Kūamahi (Community Education) has taken on. This department hopes to follow along the path of a trusted iwikuamo‘o in service to Kanaeokana.</p><p>Kanaeokana is a network of over 50 Hawaiian language, culture, and ‘āina-based organizations and schools (preschool through university level) collaborating to develop and sustain a Hawaiian education system that will nurture the next generations of aloha ‘āina leaders.</p><p>Iwikuamo‘o refers to our backbones, and both iwi and mo‘o refer to mountain ridges as well, so it gives a sense of strength and solidity. Furthermore, a kuamo‘o can be a path or a custom. Iwikuamo‘o were also highly trusted kahu, stewards, and counselors for the ali‘i. These kinds of meanings led people of the kingdom era to use iwikuamo‘o as a term of admiration for staunch po‘e aloha ‘āina who fought for our lāhui in the legislature and public sphere. Iwikuamo‘o is also the name for one of four primary star lines used by our contemporary navigators to make their way across the vast Moananuiākea. Iwikuamo‘o is a name whose primary meanings refer to strength, connectivity, trust, and navigating new paths. They are here to do whatever they can to clear these paths for us, so lean on them whenever you feelit is appropriate and they will do their best to act as kuamo‘o to help prop you up.</p> <p>Kealaiwikuamo‘o staff are directly involved in the work of the ‘Aha Kūkā, the various kōmike ho‘okō, and the Kōmike Ho‘okele, so the support needed doesn‘t need to be requested by any special process and will naturally be addressed as part and parcel of the planned and implemented work. If specific kula or hui would like to request support, though, please contact Kealaiwkuamo‘o through their director, Kēhaunani Abad.</p><h6>Some of the things that Kealaiwiakuamoʻo does include: </h6><ul><li>Provide backbone support to Kanaeokana</li><li>Provide similar backbone support to 17 Hawaiian focused charter schools comprising a significant subgroup within Kanaeokana</li><li>Develop and disseminate educational materials tailored to the needs of Kanaeokana</li><li>Communication and reporting</li><li>Manage resources provided by Kamehameha Schools to support Kanaeokana</li></ul>";

		kealaiwikuamoo.contactInfo.push(new ContactInfo(ContactInfoType.island, "Oʻahu"));
		kealaiwikuamoo.contactInfo.push(new ContactInfo(ContactInfoType.city, "Honolulu"));
		kealaiwikuamoo.contactInfo.push(new ContactInfo(ContactInfoType.address, "567 S. King Street, Suite #304, Honolulu HI  96814"));
		kealaiwikuamoo.contactInfo.push(new ContactInfo(ContactInfoType.website, ""));
		kealaiwikuamoo.contactInfo.push(new ContactInfo(ContactInfoType.email, "keabad@ksbe.edu"));
		kealaiwikuamoo.contactInfo.push(new ContactInfo(ContactInfoType.leader, "Kēhaunani Abad"));

		kealaiwikuamoo.flags = [OrganizationFlags.kanaeokanaMember, OrganizationFlags.organization];

		kealaiwikuamoo.admins = [this.kalani_waihonaUserReference, this.chjones_waihonaUserReference, this.wybartle_waihonaUserReference, this.keabad_waihonaUserReference, this.rygonzal_waihonaUserReference];
		kealaiwikuamoo.kahu = [this.chjones_waihonaUserReference, this.kalani_waihonaUserReference, this.wybartle_waihonaUserReference, this.keabad_waihonaUserReference, this.rygonzal_waihonaUserReference];
		kealaiwikuamoo.contributors = [this.chjones_waihonaUserReference, this.kalani_waihonaUserReference, this.wybartle_waihonaUserReference, this.keabad_waihonaUserReference, this.rygonzal_waihonaUserReference];

		return kealaiwikuamoo;
	}

	public getKealaiwikuamooNewUserRegistrations():Array<NewUserRegistration> {
		return [this.kalani_newUserRegistration, this.chjones_newUserRegistration, this.maui_newUserRegistration, this.keabad_newUserRegistration, this.rygonzal_newUserRegistration];
	}

	public get kalani_newUserRegistration():NewUserRegistration {
		let newUserRegistration:NewUserRegistration = new NewUserRegistration();
		newUserRegistration.guid = null;
		newUserRegistration.firstName = KealaiwikuamooStubData.first_kabright;
		newUserRegistration.altFirstName = KealaiwikuamooStubData.altFirstName_kabright;
		newUserRegistration.lastName = KealaiwikuamooStubData.last_kabright;
		newUserRegistration.email = "kabright@ksbe.edu";
		newUserRegistration.bio = "";
		newUserRegistration.professionalName = "Kalani Bright";
		newUserRegistration.organizationGuid = "kealaiwikuamoo";
		newUserRegistration.titleAtOrganization = "Bringer of Edamame";
		newUserRegistration.password = "Password1";
		newUserRegistration.confirmPassword = "Password1";
		newUserRegistration.inviteCode = "sudo!!";

		return newUserRegistration;
	}

	public get chjones_newUserRegistration():NewUserRegistration {
		let newUserRegistration:NewUserRegistration = new NewUserRegistration();
		newUserRegistration.guid = null;
		newUserRegistration.firstName = KealaiwikuamooStubData.first_chjones;
		newUserRegistration.altFirstName = KealaiwikuamooStubData.altFirstName_chjones;
		newUserRegistration.lastName = KealaiwikuamooStubData.last_chjones;
		newUserRegistration.email = "chjones@ksbe.edu";
		newUserRegistration.bio = "";
		newUserRegistration.professionalName = "Chryssa Jones";
		newUserRegistration.organizationGuid = "kealaiwikuamoo";
		newUserRegistration.titleAtOrganization = "Code Wrangler";
		newUserRegistration.password = "Password1";
		newUserRegistration.confirmPassword = "Password1";
		newUserRegistration.inviteCode = "sudo!!";

		return newUserRegistration;
	}

	public get maui_newUserRegistration():NewUserRegistration {
		let newUserRegistration:NewUserRegistration = new NewUserRegistration();
		newUserRegistration.guid = null;
		newUserRegistration.firstName = KealaiwikuamooStubData.first_wybartle;
		newUserRegistration.altFirstName = KealaiwikuamooStubData.altFirstName_wybartle;
		newUserRegistration.lastName = KealaiwikuamooStubData.last_wybartle;
		newUserRegistration.email = "wybartle@ksbe.edu";
		newUserRegistration.bio = "";
		newUserRegistration.professionalName = "Maui Bartlett";
		newUserRegistration.organizationGuid = "kealaiwikuamoo";
		newUserRegistration.titleAtOrganization = "Grammar Programmer";
		newUserRegistration.password = "Password1";
		newUserRegistration.confirmPassword = "Password1";
		newUserRegistration.inviteCode = "sudo!!";

		return newUserRegistration;
	}

	public get keabad_newUserRegistration():NewUserRegistration {
		let newUserRegistration:NewUserRegistration = new NewUserRegistration();
		newUserRegistration.guid = null;
		newUserRegistration.firstName = KealaiwikuamooStubData.first_keabad;
		newUserRegistration.altFirstName = KealaiwikuamooStubData.altFirstName_keabad;
		newUserRegistration.lastName = KealaiwikuamooStubData.last_keabad;
		newUserRegistration.email = "keabad@ksbe.edu";
		newUserRegistration.bio = "";
		newUserRegistration.professionalName = "Kēhaunani Abad";
		newUserRegistration.organizationGuid = "kealaiwikuamoo";
		newUserRegistration.titleAtOrganization = "Director of Kealaʻiwikuamoʻo";
		newUserRegistration.password = "Password1";
		newUserRegistration.confirmPassword = "Password1";
		newUserRegistration.inviteCode = "sudo!!";

		return newUserRegistration;
	}

	public get rygonzal_newUserRegistration():NewUserRegistration {
		let newUserRegistration:NewUserRegistration = new NewUserRegistration();
		newUserRegistration.guid = null;
		newUserRegistration.firstName = KealaiwikuamooStubData.first_rygonzal;
		newUserRegistration.altFirstName = KealaiwikuamooStubData.altFirstName_rygonzal;
		newUserRegistration.lastName = KealaiwikuamooStubData.last_rygonzal;
		newUserRegistration.email = "rygonzal@ksbe.edu";
		newUserRegistration.bio = "";
		newUserRegistration.professionalName = "Ryan Gonzalez";
		newUserRegistration.organizationGuid = "kealaiwikuamoo";
		newUserRegistration.titleAtOrganization = "Lead Goofball Not in Charge";
		newUserRegistration.password = "Password1";
		newUserRegistration.confirmPassword = "Password1";
		newUserRegistration.inviteCode = "sudo!!";

		return newUserRegistration;
	}

}
